import {createAction, props} from '@ngrx/store';
import {LoggedUser} from 'app/_interfaces/logged-user';
import {Version} from 'app/_interfaces/version.interface';
import {NextConsultationData} from 'app/_interfaces/next-consultation.interface';

export const login = createAction('[User] Login', props<{user: LoggedUser}>());
export const loginFromStorage = createAction('[User] Login from storage', props<{user: LoggedUser}>());
export const logout = createAction('[User] Logout');
export const initUser = createAction('[User] Init');
export const localNotPresent = createAction('[User] Local Not found');
export const checkVersion = createAction('[User] Check version', props<{appVersion: Version}>());
export const latestVersion = createAction('[User] The latest version');
export const oldVersion = createAction('[User] Old version');
export const tokenRefreshing = createAction('[User] Token refreshing', props<{isRefreshing: boolean}>());
export const logoutAfterEntrySave = createAction('[User] Logout after entry save');
export const setNextConsultation = createAction('[User] Set next consultation', props<{nextConsultation: NextConsultationData | null}>());

// fixme: only for test purposes - remove when admin mode is implemented
export const adminOn = createAction('[User] Admin mode on');
export const adminOff = createAction('[User] Admin mode off');
